import React from "react";
import { Box, Typography, CircularProgress } from "@mui/material";
import IndexCard from "../../../shared/IndexCard/IndexCard";
import { Link, useOutletContext } from "react-router-dom";

const JobListPage = () => {
  const {
    jobExists,
    isActive,
    jobs,
    loading,
    hasSearchFilters,
    handleMarkedRead,
    hasExecutedSearch,
    isSearching,
  } = useOutletContext();

  const openJobs = jobs;

  // 検索に一致する結果がない場合のメッセージ
  const shouldShowNoResultsMessage =
    hasExecutedSearch && hasSearchFilters && !isSearching;

  return (
    <Box sx={{ maxWidth: 960, mx: "auto", mt: 1, mb: 10 }}>
      {loading ? (
        <Box display="flex" justifyContent="center" mt={5}>
          <CircularProgress />
        </Box>
      ) : openJobs.length === 0 ? (
        <Typography color="text.secondary" sx={{ mt: 4 }}>
          {shouldShowNoResultsMessage ? (
            <>検索条件と一致する結果が見つかりません。</>
          ) : (
            <>
              希望条件を公開中にしていただくことで、運営局があなたの条件を確認できるようになります。
              <br />
              運営局にてご希望に沿った転職先をお探しし、条件に合う求人が見つかり次第ご紹介いたします。
              <br />
              転職先の紹介を希望される方は、希望条件を公開中でお待ちください。
            </>
          )}
        </Typography>
      ) : (
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
            gap: { xs: 1, sm: 2 },
          }}
        >
          {openJobs.map((job) => (
            <IndexCard
              key={job.id}
              item={job}
              type="job"
              component={Link}
              to={`/jobs/${job.id}`} // ユーザー向け詳細ページへ
              onMarkedRead={handleMarkedRead}
              contractExists={jobExists}
              isActive={isActive}
            />
          ))}
        </Box>
      )}
    </Box>
  );
};

export default JobListPage;
